import React from "react";
import { User, Link, Shield, Fingerprint } from "lucide-react";
import { useTranslation } from "react-i18next";

const SettingsLayout = ({ children, activeSection, onSectionChange }) => {
  const { t } = useTranslation();

  const menuItems = [
    {
      id: "account",
      label: t("account_information"),
      icon: User,
    },
    {
      id: "security",
      label: t("security_settings"),
      icon: Shield,
    },
    {
      id: "identity",
      label: t("identity_verification"),
      icon: Fingerprint,
    }
  ];

  return (
    <div className="row" style={{ backgroundColor: "var(--background)" }}>
      {/* Sidebar */}
      <div
        className="border-end col-md-3 mb-4"
        style={{
          backgroundColor: "var(--primary-color8)",
          borderColor: "var(--primary-color3)",
        }}
      >
        <div className="p-1">
          <nav>
            <div className="nav nav-pills flex-column">
              {menuItems.map((item) => {
                const Icon = item.icon;
                const isActive = activeSection === item.id;

                return (
                  <button
                    key={item.id}
                    onClick={() => onSectionChange(item.id)}
                    className={`nav-link d-flex align-items-center text-start w-100 border-0 rounded mb-2 ${
                      isActive ? "active" : ""
                    }`}
                    style={{
                      backgroundColor: isActive
                        ? "var(--primary-color5)"
                        : "transparent",
                      color: "var(--primary-color3)",
                      transition: "all 0.2s",
                    }}
                    onMouseEnter={(e) => {
                      if (!isActive) {
                        e.currentTarget.style.backgroundColor =
                          "var(--primary-color5)";
                        e.currentTarget.style.color =
                          "var(--primary-color3)";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!isActive) {
                        e.currentTarget.style.backgroundColor = "transparent";
                        e.currentTarget.style.color =
                          "var(--settings-sidebar-foreground)";
                      }
                    }}
                  >
                    <Icon size={20} className="me-3" />
                    <span className="fw-medium">{item.label}</span>
                  </button>
                );
              })}
            </div>
          </nav>
        </div>
      </div>

      {/* Main Content */}
      <div
        className="flex-fill col-md-9"
        style={{ backgroundColor: "var(--settings-content)" }}
      >
        {children}
      </div>
    </div>
  );
};

export default SettingsLayout;